import i18n from '../../locales/index'
import restful from '../vuex'
import axios from 'axios'
import { Message } from 'view-design'
import router from '@/router'
import { setToken, getToken, localSave } from '@/libs/util'

const state = {
  ...restful.states('editor'),
  access: '',
  unreadCount: 0,
  token: getToken(),
  me: {}
}

const getters = {
  ...restful.getters('editor'),
  me: (state) => state.me
}

const actions = {
  ...restful.actions('editors'),
  async login ({ commit }, params) {
    const response = await axios.post('sessions', params)
    const { auth_token, shop_ids } = response.data
    commit('setToken', auth_token)
    commit('me', response.data)

    Message.success(i18n.t('store_modules_editor_1329'))

    if (shop_ids.length) {
      localStorage.setItem('SHOPID', shop_ids[0])
      // localStorage.setItem('SHOP_NAME', shop_ids[0].name)
      // localStorage.setItem('IS_CLONED_MAIN_SHOP', shop_ids[0].is_cloned_main_shop ? '1' : '0')
      // localStorage.setItem('software_version_name', shop_ids[0].software_version_name)
    } else {
      localStorage.removeItem('SHOPID');
      localStorage.removeItem('SHOP_NAME');
      localStorage.removeItem('SHOP_TYPE');
      localStorage.removeItem('IS_CLONED_MAIN_SHOP');
      localStorage.removeItem('software_version_name')
    }
    router.replace('/shops')
  },
  async logout ({ commit }) {
    commit('setToken', '')
    localStorage.removeItem('SHOPID')
    localStorage.removeItem('SHOP_NAME');
    localStorage.removeItem('SHOP_TYPE');
    localStorage.removeItem('IS_CLONED_MAIN_SHOP');
    localStorage.removeItem('software_version_name')
    commit('me', {})
    router.replace('/login')
  },
  async change_pwd ({ commit }, params) {
    const response = await axios.post('editors/change_password', params)

    commit('setToken', response.data.auth_token)
    commit('me', response.data)
  },
  async getUserInfo ({ state, commit }) {
    return axios.get('sessions/me').then((response) => {
      commit('me', response.data)
      localSave('session-info', JSON.stringify(response.data))
      return response.data
    })
  },
  getUnreadMessageCount () {
    return 10
  }
}

const mutations = {
  ...restful.mutations('editor'),
  me (state, me) {
    state.me = me
  },
  setToken (state, token) {
    state.token = token
    setToken(token)
  },
  setMessageCount (state, count) {
    state.unreadCount = count
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
